var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"login-container"},[_c('span',{staticClass:"title"},[_vm._v("Activate your artist"+_vm._s(_vm.artists.length > 1 ? "s" : ""))]),_c('div',{staticClass:"login-content"},[(_vm.authorization.length)?_c('div',{staticClass:"card-content"},[_c('v-braintree',{attrs:{"card":{
          cvv: {
            required: true,
          },
          overrides: {
            styles: {
              input: {
                color: 'white',
              },
              ':focus': {
                color: 'white',
              },
            },
          },
        },"authorization":_vm.authorization},on:{"load":_vm.onLoad,"success":_vm.onSuccessBillingUpdate,"error":_vm.onError},scopedSlots:_vm._u([{key:"button",fn:function(slotProps){return [_c('div',{staticClass:"payment-footer"},[_c('button',{staticClass:"button-default big",attrs:{"disabled":_vm.saving || !_vm.braintreeInstance},on:{"click":function($event){$event.preventDefault();return slotProps.submit.apply(null, arguments)}}},[_c('span',[_vm._v("Get Started")])])])]}}],null,false,559370051)})],1):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }